import { defaultBannerForm, defaultBatchBannerForm } from '../form/utils';

export const initialModalState = (): BannerState => ({
  status: {
    createPdf: 'fulfilled',
    deleteFormBanners: 'fulfilled',
  },
  dynamics: {
    AV: 'À VISTA',
    AVPCJ: 'À VISTA PARCELADO COM JUROS',
    AVPSJ: 'À VISTA PARCELADO SEM JUROS',
    DP: 'DE POR',
    DPPSJ: 'DE POR PARCELADO SEM JUROS',
    LMPM: 'LEVE MAIS PAGUE MENOS',
    FD: 'FIDELIDADE',
    FDO: 'FIDELIDADE OFERTA',
    'FDD+': 'FIDELIDADE DIA +',
  },
  sizes: {
    A4: {
      width: 210,
      height: 297,
    },
    A5: {
      width: 148,
      height: 210,
    },
    A6: {
      width: 105,
      height: 148,
    },
    A7: {
      width: 74,
      height: 105,
    },
    EP21: {
      width: 74,
      height: 210,
    },
  },
  form: defaultBatchBannerForm(),
  formIndex: 0,
  forms: [],
  savedForm: defaultBatchBannerForm(),
  orientations: {
    portrait: 'Retrato',
    landscape: 'Paisagem',
  },
  configs: {
    id: 0,
    name: '',
    layouts: [],
    configs: [],
  },
  formCheck: [],
  formQuantity: [],
  isEditMode: false,
  editFormBannerId: 0,
  signature: '',
  activeTab: 0,
  singleBannerFormsToPrint: [],
  filters: {
    form: {
      filter: {
        page: 1,
        limit: 50,
        filter: [],
        orderBy: [],
      },
      data: {
        meta: {
          total: 0,
          lastPage: 1,
          currentPage: 1,
          perPage: 0,
        },
        data: [],
      },
    },
  },
  autocompletes: {
    form: {
      ean: {
        filter: {
          column: 'ean',
          value: '',
          limit: 15,
        },
        data: [],
      },
      code: {
        filter: {
          column: 'code',
          value: '',
          limit: 15,
        },
        data: [],
      },
      primary: {
        filter: {
          column: 'primary',
          value: '',
          limit: 15,
        },
        data: [],
      },
      campaign: {
        filter: {
          column: 'campaign',
          value: '',
          limit: 15,
        },
        data: [],
      },
      size: {
        filter: {
          column: 'size',
          value: '',
          limit: 15,
        },
        data: [],
      },
      dynamic: {
        filter: {
          column: 'dynamic',
          value: '',
          limit: 15,
        },
        data: [],
      },
      price: {
        filter: {
          column: 'price',
          value: '',
          limit: 15,
        },
        data: [],
      },
      discount: {
        filter: {
          column: 'discount',
          value: '',
          limit: 15,
        },
        data: [],
      },
      signature: {
        filter: {
          column: 'signature',
          value: '',
          limit: 15,
        },
        data: [],
      },
      promotionalPrice: {
        filter: {
          column: 'promotionalPrice',
          value: '',
          limit: 15,
        },
        data: [],
      },
    },
  },
  items: {
    type: [],
    promotion: [],
    products: [],
  },
});
